export default "__VITE_ASSET__DxneeuC$__"